import GridView from '@/views/GridView';
import LinkCell from '@/backgrid/LinkCell';
import StringCell from '@/backgrid/StringCell';
import _ from 'lodash';

import PageableCollection from '@/backbone/PageableCollection';

import './ReportResultsGridView.css';

const ReportResultsGridView = GridView.extend({
  className: 'reports-grid',

  initialize() {
    const self = this;

    // Map the columns to insert spaces for readability and decide if a Link Cell should be used
    // We have to do this because every report column set is different

    let columns = this.model.get('columns').map((col) => {
      col.display = col.display.replace(/([a-z])([A-Z])/g, '$1 $2').trim();
      col.display = col.display.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2').trim();
      let cellType;

      if (_.some(['OrderPackageID', 'AWPackageID'], (el) => _.includes(col.name, el))) {
        cellType = LinkCell.extend({
          name() {
            return this.column.get('name');
          },
          href(model) {
            let column = this.column.get('name');
            return `#${column === 'OrderPackageID' ? 'order-package' : 'aw-package'}/${this.model.get(column)}`;
          },
          newTab: true
        });
      } else {
        cellType = StringCell;
      }

      return {
        name: col.name,
        label: col.display,
        cell: cellType,
        headerCell: 'custom',
        editable: false
      };
    });

    this.options.columns = columns;

    this.options.collection = new PageableCollection(this.model.get('data'));

    this.options.emptyText = 'No Data Found in Report';
  }
});

export default ReportResultsGridView;
